export default __webpack_public_path__ + "static/media/IBLHL.18f2b8c0.png";